// extracted by mini-css-extract-plugin
export var colImg = "MpFFW";
export var contentWrapper = "X8qYq";
export var cta = "ykZwS";
export var imageWrapper = "HYFNC";
export var plainText = "O6b7i";
export var title = "iSbCo";